module.exports = __webpack_public_path__ + "static/media/EmailTemplatesEmpty.28f2db76.png";